"use client";

import { useEffect, type ReactNode } from "react";
import useUserStore from "@/store/user/use-user-store";

const Wrapper = ({ children }: { children: ReactNode }) => {
  const setCurrentTime = useUserStore((state) => state.setCurrentTime);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(Math.floor(Date.now() / 1000));
    }, 1000);
    return () => clearInterval(interval);
  }, [setCurrentTime]);

  return <>{children}</>;
};

export default Wrapper;
